import { CONTAINER_TYPES } from '@src/quince-site-common/src/organisms/pageBuilder'
import { IContainerConfig } from '@src/quince-site-common/src/organisms/pageBuilder/pageBuilder.domains'

import {
  DESKTOP_DISCLAIMER,
  DESKTOP_FAQ,
  DESKTOP_FBT,
  DESKTOP_INFLUENCER,
  DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
  DESKTOP_PRODUCT_IMAGES_AND_PURCHASE,
  DESKTOP_PRODUCT_REVIEWS,
  DESKTOP_SIMILAR_PRODUCTS,
  DESKTOP_TRANSPARENT_PRICING,
  DESKTOP_YOU_MAY_ALSO_LIKE,
} from '../common'
import {
  MOBILE_BRAND_COMPARISON,
  MOBILE_DISCLAIMER,
  MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
  MOBILE_INFLUENCER,
  MOBILE_INFORMATION_BOXES,
  MOBILE_PAIR_WITH,
  MOBILE_PRODUCT_DETAILS_AND_CARE,
  MOBILE_PRODUCT_IMAGES,
  MOBILE_PRODUCT_PURCHASE,
  MOBILE_PRODUCT_REVIEWS,
  MOBILE_REVIEW_HIGHLIGHTS,
  MOBILE_SIMILAR_PRODUCTS,
  MOBILE_TRANSPARENT_PRICING,
  MOBILE_YOU_MAY_ALSO_LIKE,
} from '../common/mobile'

export const defaultDesktopConfig: IContainerConfig = {
  id: 'DESKTOP_DEFAULT_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    DESKTOP_PRODUCT_IMAGES_AND_PURCHASE,
    DESKTOP_PRODUCT_DETAILS_CARES_BRAND_COMPARISON_PAIR_WITH,
    DESKTOP_SIMILAR_PRODUCTS,
    DESKTOP_PRODUCT_REVIEWS,
    DESKTOP_TRANSPARENT_PRICING,
    DESKTOP_INFLUENCER,
    DESKTOP_FBT,
    DESKTOP_FAQ,
    DESKTOP_YOU_MAY_ALSO_LIKE,
    DESKTOP_DISCLAIMER,
  ],
}

export const defaultMobileConfig: IContainerConfig = {
  id: 'MOBILE_DEFAULT_MOBILE_CONFIG_ROOT',
  containerType: CONTAINER_TYPES.ROW,
  children: [
    MOBILE_PRODUCT_IMAGES,
    MOBILE_PRODUCT_PURCHASE,
    MOBILE_REVIEW_HIGHLIGHTS,
    MOBILE_PRODUCT_DETAILS_AND_CARE,
    MOBILE_BRAND_COMPARISON,
    MOBILE_PAIR_WITH,
    MOBILE_SIMILAR_PRODUCTS,
    MOBILE_TRANSPARENT_PRICING,
    MOBILE_INFLUENCER,
    MOBILE_INFORMATION_BOXES,
    MOBILE_FREQUENTLY_BOUGHT_TOGETHER,
    MOBILE_PRODUCT_REVIEWS,
    MOBILE_YOU_MAY_ALSO_LIKE,
    MOBILE_DISCLAIMER,
  ],
}
